/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  uploadMaterial(assistantId, formData) {
    return axios.post(`${this.url}/${assistantId}/materials`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeMaterial(assistantId, key) {
    return axios.delete(
      `${this.url}/${assistantId}/materials/${encodeURIComponent(key)}`
    );
  }

  getTools() {
    return axios.get(`${this.url}/tools`);
  }

  getToolPacks() {
    return axios.get(`${this.url}/tool_packs`);
  }

  updateToolPacks(packs) {
    return axios.post(`${this.url}/tool_packs`, { packs });
  }

  // #1: allowlist de tools por conta (admin) — habilita tools privadas/bespoke
  // ou de pacote para um cliente específico.
  getAccountTools() {
    return axios.get(`${this.url}/account_tools`);
  }

  updateAccountTools(toolIds) {
    return axios.post(`${this.url}/account_tools`, { tool_ids: toolIds });
  }

  // #6: clona o agente como template (cria uma cópia com prompt, ferramentas,
  // regras de campos, guardrails, agendas e cenários — sem materiais nem
  // conhecimento treinado). Retorna o novo assistant.
  clone(assistantId) {
    return axios.post(`${this.url}/${assistantId}/clone`);
  }
}

export default new CaptainAssistant();
